export enum AuthorityManifestationRecipient {
  FISCAL_INVOICE_RECIPIENT_STATEMENT = '4.4',
}
